import { render, staticRenderFns } from "./OnizleForm.vue?vue&type=template&id=483c5f58"
import script from "./OnizleForm.vue?vue&type=script&lang=ts"
export * from "./OnizleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports